// YadsEditScheduleActions.js
import {
  PATCH_YADS_TENANT_REQUEST,
  PATCH_YADS_TENANT_SUCCESS,
  PATCH_YADS_TENANT_FAILURE,
  PATCH_YADS_TENANT_RESET,
  RESCHEDULE_YADS_REQUEST,
  RESCHEDULE_YADS_SUCCESS,
  RESCHEDULE_YADS_FAILURE,
  RESCHEDULE_YADS_RESET,
} from '../../../Constants/actionTypes';

import {
  patchYadsTenantDetails,
  postYadsReschedule,
} from '../../../Constants/apiService';

// ---- PATCH (tenant-only) ----
export const patchYadsTenantRequest = () => ({ type: PATCH_YADS_TENANT_REQUEST });
export const patchYadsTenantSuccess = (data) => ({ type: PATCH_YADS_TENANT_SUCCESS, payload: data });
export const patchYadsTenantFailure = (err) => ({ type: PATCH_YADS_TENANT_FAILURE, payload: err });
export const patchYadsTenantReset   = () => ({ type: PATCH_YADS_TENANT_RESET });

export const updateYadsTenantDetails = (taskId, tenantPayload) => {
  return async (dispatch, getState) => {
    dispatch(patchYadsTenantRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await patchYadsTenantDetails(taskId, tenantPayload, accessToken);
      dispatch(patchYadsTenantSuccess(res));
    } catch (error) {
      const msg = error.message?.includes('fetch')
        ? 'Unable to update tenant. Please try again.'
        : error.message;
      dispatch(patchYadsTenantFailure(msg));
    }
  };
};

// ---- POST (scenario and/or schedule changes) ----
export const rescheduleYadsRequest = () => ({ type: RESCHEDULE_YADS_REQUEST });
export const rescheduleYadsSuccess = (data) => ({ type: RESCHEDULE_YADS_SUCCESS, payload: data });
export const rescheduleYadsFailure = (err) => ({ type: RESCHEDULE_YADS_FAILURE, payload: err });
export const rescheduleYadsReset   = () => ({ type: RESCHEDULE_YADS_RESET });

export const rescheduleYadsScenario = (taskId, payload) => {
  return async (dispatch, getState) => {
    dispatch(rescheduleYadsRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await postYadsReschedule(taskId, payload, accessToken);
      dispatch(rescheduleYadsSuccess(res));
    } catch (error) {
      const msg = error.message?.includes('fetch')
        ? 'Unable to reschedule. Please try again.'
        : error.message;
      dispatch(rescheduleYadsFailure(msg));
    }
  };
};
